module.exports = __webpack_public_path__ + "img/005王利雄.e7a981b4.jpg";